module.exports = __webpack_public_path__ + "media/images/photo/group423-d45c1ef44d0e6acd87a21a7b7db5ed1b.png";